import { NewsPost } from '../models/news-post';

export type GroupedNewsPosts = {
    date: Date;
    posts: NewsPost[];
};

export const groupByMonthAndYear = (mockNewsPosts: NewsPost[]): GroupedNewsPosts[] => {
    const groups = mockNewsPosts.reduce((allNews: Record<string, NewsPost[]>, singleNews) => {
        const date = new Date(singleNews.publishAt.getFullYear(), singleNews.publishAt.getMonth(), 1).toDateString();

        if (!allNews[date]) {
            allNews[date] = [];
        }
        allNews[date].push(singleNews);
        return allNews;
    }, {});

    return Object.keys(groups)
        .map(date => {
            return {
                date: new Date(date),
                posts: groups[date].sort((a: NewsPost, b: NewsPost) => b.publishAt.getTime() - a.publishAt.getTime()),
            };
        })
        .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
};
